import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  {
    q: "Je online casino v Česku legální?",
    a: "Ano, online casino je legální a je regulováno Ministerstvem financí ČR v souladu se zákonem o hazardních hrách.",
  },
  {
    q: "Jak zjistit, že je casino spolehlivé?",
    a: "Zkontrolujte licenci vydanou českými nebo evropskými regulátory. Věnujte pozornost certifikátům nezávislých auditorů.",
  },
  {
    q: "Jaké způsoby platby jsou dostupné v českých online casinech?",
    a: "Mezi oblíbené metody patří Visa, Mastercard, bankovní převody, elektronické peněženky (Skrill, Neteller) a někdy i kryptoměny.",
  },
  {
    q: "Jsou bonusy dostupné pro hráče z Česka?",
    a: "Ano, mnoho kasin nabízí uvítací bonusy, free spiny a akce pro stálé zákazníky.",
  },
  {
    q: "Mohu hrát z mobilního zařízení?",
    a: "Ano, většina online casin je optimalizována pro mobilní zařízení a nabízí aplikace: častěji pro Android, méně často pro iOS.",
  },
  {
    q: "Jaké hry jsou dostupné v českých online kasinech?",
    a: "Hráči si mohou užívat sloty, ruletu, blackjack, poker a také hry s živými dealery a herní show.",
  },
  {
    q: "Jsou online kasina v Česku bezpečná?",
    a: "Licencovaná kasina využívají moderní šifrovací technologie a dodržují bezpečnostní standardy, které zajišťují ochranu údajů hráčů.",
  },
];

export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 bg-white" data-testid="section-faq">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <h2 className="text-3xl font-black text-gray-900 mb-2">FAQ Sekce</h2>
        </div>

        <div className="flex flex-col gap-2" data-testid="faq-accordion">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl border border-gray-100 bg-white hover-elevate overflow-visible"
              data-testid={`faq-item-${i}`}
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-semibold text-gray-900 text-sm leading-normal pr-2">{faq.q}</span>
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-gray-50 flex items-center justify-center text-gray-400">
                  {openIndex === i ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-48 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-5 pb-5">
                  <div className="w-full h-px bg-gray-100 mb-3" />
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
